import templateUrl from 'emun.salesrep/salesrep-sales-goals-chart.htm'
class SalesRepSalesGoalsChartController {
    constructor($window, $rootScope, retailerPrompt, createAutoQuery) { 
        let $ctrl = this;
        $ctrl.chartLoaded = false;
        this.quarterSales = {
            total: 0,
            count: 0
        };
        this.ytdSales = {
            total: 0,
            count: 0
        };
        this.monthSales = {
            total: 0,
            count: 0
        };

        this.chartOptions = {
            maintainAspectRatio: false,
            legend: { 
                display: true 
            },
            scales: {
                yAxes: [{
                    display: true,
                    ticks: {
                        callback: function(value, index, values) {
                            return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                    }
                }]
            },
            tooltips: {
                enabled: true,
                callbacks: {
                    label: function(tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label ;
                        var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        //                        return label + ': ' + $filter('currency')(datasetLabel);
                    }
                }
            },
        }

        var context = $ctrl.context || 'rep';

        var filter = "SalesRepID";
        if (context == 'manager') { filter = "ManagerId";}

        this.monthSalesQuery = createAutoQuery({
            url: 'QueryOrderTotals.json?dateRange=Month&' + filter + '=' + this.rep.id,
            autoLoad: true,
            onLoaded: function(args) {
                $ctrl.monthSales.total = args.first.total;
                $ctrl.monthSales.count = args.first.count;
                $ctrl.quarterSalesQuery = createAutoQuery({
                    url: 'QueryOrderTotals.json?dateRange=Quarter&' + filter + '=' + $ctrl.rep.id,
                    autoLoad: true,
                    onLoaded: function(args) {
                        $ctrl.quarterSales.total = Math.round(args.first.total);
                        $ctrl.quarterSales.count = args.first.count;
                        $ctrl.ytdSalesQuery = createAutoQuery({
                            url: 'QueryOrderTotals.json?dateRange=YTD&' + filter + '=' + $ctrl.rep.id,
                            autoLoad: true,
                            onLoaded: function(args) {
                                $ctrl.ytdSales.total = Math.round(args.first.total);
                                $ctrl.ytdSales.count = args.first.count;
                                $ctrl.goalChartLabels = ["Month", "Quarter", "Year"];
                                $ctrl.goalChartSeries = ["Sales","Goal"];

                                $ctrl.goalChartData = [];
                                var today = new Date();
                                $ctrl.loadGoalChartData = function(args) {
                                    $ctrl.goalChartLabels = ["Month", "Quarter", "Year"];
                                    $ctrl.goalChartSeries = ["Sales","Goal"];
                                    $ctrl.goalChartData = [];
                                    var flags = [];

                                    var goalSeriesData = [Math.round($ctrl.monthSales.total),Math.round($ctrl.quarterSales.total),Math.round($ctrl.ytdSales.total)];
                                    $ctrl.goalChartData.push(goalSeriesData);

                                    var qtrGoal = 0;
                                    var qtr1Goal = 0;
                                    var qtr2Goal = 0;
                                    var qtr3Goal = 0;
                                    var qtr4Goal = 0;
                                    var monthGoal = 0;
                                    var totalGoal = 0;
                                    var thisMonth = moment().month() + 1;
                                    args.results.forEach(function(r) {
                                        var month = r.month; //moment(r.month).month();
                                        //console.info("BL*** month = " + month);
                                        if (month == 0 || month == 1 || month == 2) {
                                            qtr1Goal += r.goal;
                                        } else if (month == 3 || month == 4 || month == 5) {
                                            qtr2Goal += r.goal;
                                        } else if (month == 6 || month == 7 || month == 8) {
                                            qtr3Goal += r.goal;
                                        } else if (month == 9 || month == 10 || month == 11) {
                                            qtr4Goal += r.goal;
                                        }
                                        if (month == thisMonth) {
                                            monthGoal = r.goal;
                                        }
                                        if (month <= thisMonth) {
                                            totalGoal += r.goal;
                                        }
                                    });
                                    if (moment().quarter() == 1) {
                                        qtrGoal = Math.round(qtr1Goal);
                                    } else if (moment().quarter() == 2) {
                                        qtrGoal = Math.round(qtr2Goal);
                                    } else if (moment().quarter() == 3) {
                                        qtrGoal = Math.round(qtr3Goal);
                                    } else if (moment().quarter() == 4) {
                                        qtrGoal = Math.round(qtr4Goal);
                                    }
                                    var goalSeriesData = [Math.round(monthGoal),qtrGoal,Math.round(totalGoal)];
                                    $ctrl.goalChartData.push(goalSeriesData);
                                    $ctrl.chartLoaded = true;

                                }
                                $ctrl.salesGoals = createAutoQuery({
                                    url: 'QueryRepMonthlyGoals.json?' + filter + '=' + $ctrl.rep.id,
                                    autoLoad: true,
                                    onLoaded: args => {$ctrl.loadGoalChartData(args);}
                                });
                            }
                        });
                    }
                });
            }
        });

    }
}

let SalesRepSalesGoalsChart = {
    bindings: {
        rep: '<',
        context: '@'
    },
    //require:{
    //    container: '^salesrepDashboard'
    //},
    controller: SalesRepSalesGoalsChartController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}


export default SalesRepSalesGoalsChart